
<!-- <p class="pb-5">This is all just fake data for now but it's coded to be easily hooked up to the API when it's ready.</p> -->

<ui-panel
  panelTitle="Test Case Number"
  [panelHeaderConfig]="{ leftInputs: inputConfig }"
  [leftInputsFormValues]="formValues"
  (leftInputsFormValuesChange)="onFormValuesChange($event)"
>
  <div class="p-5" >
    <!-- <app-case-summary-bar style="z-index: 2; position: relative;" -->
    <app-case-summary-bar
      [caseId]="formValues.caseId"
    />
  </div>
</ui-panel>